import { Stack, List, ListItemText, Divider, Typography } from '@mui/material';
import { Fragment } from 'react';

type CustomRuleDetailsListProps = {
  list: string[];
  title: string;
  testIdSuffix: string;
};

const CustomRuleDetailsList = ({
  list,
  title,
  testIdSuffix,
}: CustomRuleDetailsListProps) => {
  return (
    <Stack>
      <Typography
        sx={{ mb: 1 }}
        variant="h6"
        data-testid={`CustomRuleDetailsList.Title.${testIdSuffix}`}
      >
        {title}
      </Typography>
      <List component="span">
        {list.map(item => (
          <Fragment key={item}>
            <ListItemText
              primary={item}
              data-testid={`CustomRuleDetailsList.ListItemText.${testIdSuffix}`}
            />
            <Divider />
          </Fragment>
        ))}
      </List>
    </Stack>
  );
};

export default CustomRuleDetailsList;
